import { DateCellComponent, Modal, Span } from '@uni-space/uni-components';
import { useTranslation } from 'react-i18next';
import { ParcelPhotoDto, ParcelPhotoType } from '../model/parcel';
import './ParcelPhotosModal.scss';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  trackNumber: string;
  photos: ParcelPhotoDto[];
}

/**
 * Все фото посылки из Media: фото приёмки и фото отмены (запрещённое вложение). Ссылки presigned
 * и временные, поэтому картинка открывается по клику в новой вкладке, а не скачивается заранее.
 */
export default function ParcelPhotosModal({ isOpen, onClose, trackNumber, photos }: Props) {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="ppm">
        <Span fs={18}>{t('parcelPhotos.title', { trackNumber })}</Span>

        {photos.length === 0 ? (
          <div className="ppm-empty">{t('photoIsEmpty')}</div>
        ) : (
          <div className="ppm-grid">
            {photos.map((photo) => {
              const isCancellation = photo.photoType === ParcelPhotoType.Cancellation;
              return (
                <div key={photo.id} className={isCancellation ? 'ppm-card ppm-card--cancellation' : 'ppm-card'}>
                  {photo.url ? (
                    <a href={photo.url} target="_blank" rel="noreferrer" title={t('parcelPhotos.open')}>
                      <img className="ppm-image" src={photo.url} alt={trackNumber} />
                    </a>
                  ) : (
                    <div className="ppm-image ppm-image--empty">{t('parcelPhotos.noLink')}</div>
                  )}
                  <div className="ppm-meta">
                    <span className={isCancellation ? 'ppm-chip ppm-chip--danger' : 'ppm-chip ppm-chip--success'}>
                      {isCancellation ? t('parcelPhotos.type.cancellation') : t('parcelPhotos.type.acceptance')}
                    </span>
                    <DateCellComponent date={photo.createdAt} zone="local" />
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </Modal>
  );
}
